// components/Layout.js
import React, { useEffect, useState } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import Footer from "./Footer";
import Header from "./Header";

const Layout = ({ children }) => {
  const router = useRouter();
  const [footerVisible, setFooterVisible] = useState(true);

  useEffect(() => {
    // 개인정보 보호와 계약 화면은 Footer 안보이게 함.
    if (router.asPath === "/privacy" || router.asPath === "/terms") setFooterVisible(false);
    else setFooterVisible(true);
  }, [router]);

  return (
    <div className="w-full h-screens">
      <Head>
        <meta property="og:title" content="Enkino AI" key="title" />
        <meta name="description" content="엔키노 AI 공식 홈페이지 입니다."></meta>
        <title>엔키노 에이아이 홈페이지 입니다</title>
      </Head>
      <Header />
      <div className="w-full h-screen pt-16">{children}</div>
      {footerVisible ? <Footer /> : null}
    </div>
  );
};

export default Layout;
